<template>
  <b-container fluid>
    <center>
      <h3>Welkom {{ $authService.username }} bij de MomaVitals Portal</h3>
      <img src="../assets/Schaar.png" />
    </center>
</b-container>
</template>

<script>  
  export default {
    name: 'Home',
    data() {
      return {       
      }
    }
  }
</script>

<style scoped>
  a.disabled {
    pointer-events: none;
  }
</style>



// WEBPACK FOOTER //
// src/components/Home.vue